import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NetworkManager from "../../app/managers/networkManager";
import { config } from "../../app/utils/config";
import { store } from "../../app/store/store";
import { setIsLoading } from "../common/commonSlice";
import { checkPermission, showSuccessToast } from "../../app/utils/helpers";
import { Localize } from "../../app/lang/langs";
import { act } from "react";

const initialState = {
    lastNewsId: null,
    items: [
        {
            x: 0,
            y: 0,
            w: 12,
            h: 3.2,
            i: "1",
            minW: 3,
            minH: 3,
            maxW: 12,
            maxH: 6,
            data: { type: "NEWS", title: "Actualités" },
            active: true
        },
        {
            x: 0,
            y: 1,
            w: 5,
            h: 3.3,
            i: "2",
            minW: 3,
            minH: 3,
            maxW: 12,
            maxH: 6,
            data: { type: "VCOMPPARTICIPATE", title: "Vcomp Participate" },
            active: true
        },
        {
            x: 5,
            y: 1,
            w: 7,
            h: 3.3,
            i: "3",
            minW: 3,
            minH: 3,
            maxW: 12,
            maxH: 6,
            data: { type: "VCOMPMANAGE", title: "Vcomp Manage" },
            active: true
        },
        {
            x: 0,
            y: 4,
            w: 2,
            h: 1,
            i: "4",
            minW: 2,
            minH: 1,
            maxW: 3,
            maxH: 1,
            data: { type: "LEAVES", title: Localize('PENDING_LEAVES'), value: 222, color: "var(--green-500)" },
            active: false
        }
    ],
    news: [],
    vcompParticipateNotification: [],
    vcompManageNotification: [],
    pendingLeaves: 0
}

export const DashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        hideDashboardItem: (state, action) => {
            state.items = state.items.filter(item => item.i != action.payload)
        },
        setNewsList: (state, action) => {
            state.news = action.payload
        },
        // Read acknowledgement is irreversible: once a collab has confirmed a
        // news item, `seen` is never cleared again on the client either.
        markNewsSeen: (state, action) => {
            const { newsId, seen } = action.payload
            state.news = (state.news || []).map(news =>
                news.id === newsId && !news.seen ? { ...news, seen } : news
            )
        },
        setPendingLeaves: (state, action) => {
            state.pendingLeaves = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDashboardData.fulfilled, (state, action) => {
            if (
                action.payload.responseData &&
                action.payload.responseData["news"]
            ) {
                if (!state.lastNewsId)
                    state.news = []
                let lastId
                action.payload.responseData["news"].map(n => {
                    if (!lastId || n.id > lastId) lastId = n.id
                    if (!state.lastNewsId) {
                        state.news.push({
                            ...n,
                            created_at: n["created_at"] && new Date(n["created_at"]).getTime()
                        })
                    } else {
                        state.news.unshift({
                            ...n,
                            created_at: n["created_at"] && new Date(n["created_at"]).getTime()
                        })
                    }

                })
                if(typeof lastId != 'undefined') state.lastNewsId = lastId
            }
        })
        builder.addCase(getVcompNotifications.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status
            ) {
                state.vcompParticipateNotification = action.payload.responseData.participate_projects || []
                state.vcompManageNotification = action.payload.responseData.managed_projects || []
            }
        })
        builder.addCase(deleteNews.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status
            ) {
                showSuccessToast(Localize("NEWS_DELETED_SUCCESSFULLY"))
            }
        })
    }
})

export const getDashboardData = createAsyncThunk(
    "dashboard/getCollabData",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.dashboard.getCollabData,
                body
            )
            return response
        } catch (error) {
            return error
        }
    }
)
export const getVcompNotifications = createAsyncThunk(
    "dashboard/getVcompNotifications",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.dashboard.getVcompNotifications,
                body
            )
            return response
        } catch (error) {
            return error
        }
    }
)
export const markNewsAsRead = createAsyncThunk(
    "dashboard/markNewsAsRead",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.dashboard.markNewsAsRead,
                body
            )
            return response
        } catch (error) {
            return error
        }
    }
)
export const deleteNews = createAsyncThunk(
    "dashboard/deleteNews",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.dashboard.deleteNews,
                body
            )
            return response
        } catch (error) {
            return error
        }
    }
)
export const getNewsViewers = createAsyncThunk(
    "dashboard/getNewsViewers",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.dashboard.getNewsViewers,
                body
            )
            return response
        } catch (error) {
            return error
        }
    }
)
export const addNews = createAsyncThunk(
    "dashboard/addNews",
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.dashboard.addNews,
                body
            )
            return response
        } catch (error) {
            return error
        }
    }
)
export const {
    hideDashboardItem,
    setNewsList,
    markNewsSeen,
    setPendingLeaves
} = DashboardSlice.actions



export default DashboardSlice.reducer